import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import Form from 'react-bootstrap/Form'
import { createSchedaSpese } from '../features/schedaSpese/schedaSpeseSlice'
import EmailShareList from './utils/EmailShareList';

export const CREATE_SCHEDA_FORM_ID = 'create-scheda-form';

function SchedaSpeseForm({ onSuccess, formId = CREATE_SCHEDA_FORM_ID }) {

  const [formData, setFormData] = useState({
    titolo: '',
    inserimentoData: '',
    utentiList: []
  })

  const { titolo, inserimentoData, utentiList } = formData

  const dispatch = useDispatch()

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  const onSubmit = (e) => {
    e.preventDefault()

    if (!titolo) {
      toast.error('Please fill in all required fields')
    } else {
      const schedaSpeseFormData = {
        titolo,
        inserimentoData: inserimentoData || new Date().toISOString(),
        utentiList: utentiList
      }

      dispatch(createSchedaSpese(schedaSpeseFormData))
      .unwrap()
      .then((response) => {
        toast.success("Nota spese creata con successo!");
        onSuccess();
      })
      .catch((error) => {
        console.error("Error Response:", error); // Debugging
        toast.error(error.message || "Errore nella creazione della nota spese");
      });
    }
  }

  const addEmail = (newEmailEntry) => {
    setFormData((prev) => ({
      ...prev,
      utentiList: [...prev.utentiList, newEmailEntry],
    }));
  };

  const removeEmail = (email) => {
    setFormData((prev) => ({
      ...prev,
      utentiList: prev.utentiList.filter((entry) => entry.email !== email),
    }));
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }


  return (
    // No submit button here - the modal footer owns it and targets this form
    // via the `form` attribute, matching ShareModal's SHARE_FORM_ID pattern.
    <Form id={formId} onSubmit={onSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Titolo *</Form.Label>
        <Form.Control
          className="dashboard-input"
          type="text"
          id="titolo"
          name="titolo"
          value={titolo}
          placeholder="GENNAIO"
          onChange={onChange}
          required
        />
      </Form.Group>

      <EmailShareList
        emailList_tmp={utentiList}
        onAddEmail={addEmail}
        onValidateEmail={validateEmail}
        onRemoveEmail={removeEmail}
      />
    </Form>
  )
}

export default SchedaSpeseForm
